'use client';

import CmsBlockGroup from '@/components/CmsBlock';
import classes from './privacyPolicyPage.module.css';

export const PrivacyPolicyPage = () => {
  const pageTitle = 'PRIVACY POLICY';

  const handleAfterEffect = () => {
    const anchors = document.getElementsByClassName('seemore');

    for (let i = 0; i < anchors.length; i++) {
      anchors[i].onclick = e => {
        const anchor = e.target;
        anchor.textContent = anchor.textContent === 'See More...' ? 'See Less...' : 'See More...';

        const nextDiv = anchor.nextElementSibling;

        if (!nextDiv) return;

        if (nextDiv.classList.contains('hide')) {
          nextDiv.classList.remove('hide');
        } else {
          nextDiv.classList.add('hide');
        }
      };
    }
  };

  return (
    <div className={classes.privacypolicy}>
      <h1 className={classes.title}>{pageTitle}</h1>
      <CmsBlockGroup
        classes={{
          root: classes.root,
        }}
        identifiers={'privacy-policy'}
        resolveRelativePath={!!process.env.NEXT_PUBLIC_BASE_PATH}
        afterEffect={handleAfterEffect}
      />
    </div>
  );
};

export default PrivacyPolicyPage;
